import BaseService from "@/services/base.service";
import { getConfigSetup, getStateStore } from "@/utils/utils";

const configSetup = getConfigSetup();
const state = getStateStore();

const userInfo: any = state.userInfo;
interface reportInterface {
    from: string;
    to: string;
}

class ReportService extends BaseService {
    async report(param: reportInterface) {
        const { from, to } = param;
        return await this.get(
            `${configSetup.apiUrl}/api/retail/report/report-by-cashier-and-game?admin_user_id=${userInfo?.details?.id}&from=${from}&to=${to}`
        ).then(({ data }) => data);
    }

    async makeAFinalReport() {
        const response = await this.post(
            `${configSetup.apiUrl}/api/retail/cashier/self-lock`,
            ""
        );
        return response.data;
    }
}

export default new ReportService();
